/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from '@react-navigation/native';
import * as Linking from 'expo-linking';

import { RootStackParamList } from '../types';

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL('/')],
  config: {
    screens: {
      Root: {
        screens: {
          Profile: {
            screens: {
              TabOneScreen: 'one',
            },
          },
          Chat: {
            screens: {
              TabTwoScreen: 'two',
            },
          },
          Names: {
            screens: {
              TabTwoScreen: 'three',
            },
          },
          Dice: {
            screens: {
              TabTwoScreen: 'four',
            },
          },
          Dm: {
            screens: {
              TabTwoScreen: 'five',
            },
          },
        },
      },
      Modal: 'modal',
      NotFound: '*',
    },
  },
};

export default linking;
